import { render, staticRenderFns } from "./tutorCertificate.vue?vue&type=template&id=3b17f75f&scoped=true&"
import script from "./tutorCertificate.vue?vue&type=script&lang=js&"
export * from "./tutorCertificate.vue?vue&type=script&lang=js&"
import style0 from "./tutorCertificate.vue?vue&type=style&index=0&id=3b17f75f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b17f75f",
  null
  
)

export default component.exports